"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStoredHrLineStyle = exports.getStoredHrBlockHeight = exports.getStoredHrLineWidth = exports.getStoredHrStrokeWidth = exports.getHrLineStyle = exports.getHrBlockHeight = exports.getHrLineWidth = exports.getHrStrokeWidth = exports.HR_LINE_STYLES = exports.HR_BLOCK_HEIGHT_MAX = exports.HR_BLOCK_HEIGHT_MIN = exports.HR_LINE_WIDTH_MAX = exports.HR_LINE_WIDTH_MIN = exports.HR_STROKE_WIDTH_MAX = exports.HR_STROKE_WIDTH_MIN = exports.DEFAULT_HR_BLOCK_HEIGHT = exports.DEFAULT_HR_LINE_STYLE = exports.DEFAULT_HR_LINE_WIDTH = exports.DEFAULT_HR_STROKE_WIDTH = void 0;
exports.DEFAULT_HR_STROKE_WIDTH = 1;
exports.DEFAULT_HR_LINE_WIDTH = 100;
exports.DEFAULT_HR_LINE_STYLE = 'solid';
exports.DEFAULT_HR_BLOCK_HEIGHT = 32;
exports.HR_STROKE_WIDTH_MIN = 0;
exports.HR_STROKE_WIDTH_MAX = 12;
exports.HR_LINE_WIDTH_MIN = 1;
exports.HR_LINE_WIDTH_MAX = 100;
exports.HR_BLOCK_HEIGHT_MIN = 8;
exports.HR_BLOCK_HEIGHT_MAX = 500;
exports.HR_LINE_STYLES = ['solid', 'dashed', 'dotted', 'squiggly'];
const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
const numberOrDefault = (value, fallback, min, max) => {
    if (typeof value !== 'number' || !Number.isFinite(value))
        return fallback;
    return clamp(Math.round(value), min, max);
};
const getHrStrokeWidth = (value) => numberOrDefault(value, exports.DEFAULT_HR_STROKE_WIDTH, exports.HR_STROKE_WIDTH_MIN, exports.HR_STROKE_WIDTH_MAX);
exports.getHrStrokeWidth = getHrStrokeWidth;
const getHrLineWidth = (value) => numberOrDefault(value, exports.DEFAULT_HR_LINE_WIDTH, exports.HR_LINE_WIDTH_MIN, exports.HR_LINE_WIDTH_MAX);
exports.getHrLineWidth = getHrLineWidth;
const getHrBlockHeight = (value) => numberOrDefault(value, exports.DEFAULT_HR_BLOCK_HEIGHT, exports.HR_BLOCK_HEIGHT_MIN, exports.HR_BLOCK_HEIGHT_MAX);
exports.getHrBlockHeight = getHrBlockHeight;
const getHrLineStyle = (value) => value && exports.HR_LINE_STYLES.includes(value) ? value : exports.DEFAULT_HR_LINE_STYLE;
exports.getHrLineStyle = getHrLineStyle;
const getStoredHrStrokeWidth = (value) => {
    const next = (0, exports.getHrStrokeWidth)(value);
    return next === exports.DEFAULT_HR_STROKE_WIDTH ? undefined : next;
};
exports.getStoredHrStrokeWidth = getStoredHrStrokeWidth;
const getStoredHrLineWidth = (value) => {
    const next = (0, exports.getHrLineWidth)(value);
    return next === exports.DEFAULT_HR_LINE_WIDTH ? undefined : next;
};
exports.getStoredHrLineWidth = getStoredHrLineWidth;
const getStoredHrBlockHeight = (value) => {
    const next = (0, exports.getHrBlockHeight)(value);
    return next === exports.DEFAULT_HR_BLOCK_HEIGHT ? undefined : next;
};
exports.getStoredHrBlockHeight = getStoredHrBlockHeight;
const getStoredHrLineStyle = (value) => {
    const next = (0, exports.getHrLineStyle)(value);
    return next === exports.DEFAULT_HR_LINE_STYLE ? undefined : next;
};
exports.getStoredHrLineStyle = getStoredHrLineStyle;
